package com.mshopsas.enterprise.aiw.scan.data

data class Location(
    val latitude: Double,
    val longitude: Double
)
